import PosthogService from '~/services/posthog/PosthogService';

export type TCandidateListAdditionalDetailsAction = 'expand' | 'collapse';

export interface ICandidateListAdditionalDetailsClickedPayload {
  /** What the click did: `expand` opened the panel, `collapse` closed it. */
  action: TCandidateListAdditionalDetailsAction;
}

/**
 * Fires when an office opens or closes the Additional Information panel on the
 * redesigned Confirm Candidates page (GOTU-8158).
 *
 * Event: dental_portal:candidate_list:additional_details_clicked
 */
export function fireCandidateListAdditionalDetailsClicked(
  payload: ICandidateListAdditionalDetailsClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:candidate_list:additional_details_clicked', {
    action: payload.action,
  });
}
